export const API_CONSTANTS = {
    auth: '/auth',
    refresh: '/refresh',
    users: '/Users',
    password: '/password',
    reset: '/reset',
    transient: '/transient',
    dashboard: '/dashboard',
    associates: '/associates',
    customers: '/customers',
    customer: '/customer',
    brokers: '/brokers',
    loads: '/loads',
    drivers: '/drivers',
    attachments: '/attachments',
    shipments: '/shipments',
    dispatch: '/dispatch',
    pindrops: '/pindrops',
    rates: '/rates',
    commodity: '/commodity',
    taggroups: '/taggroups',
    truckingcompany: '/truckingcompany',
    setting: '/setting',
    invoice: '/invoice',
    invoices: '/invoices',
    tenant: '/tenant',
    signUp: '/signupnewtenant',
    verifySubscription: '/verifysubscription',
    breakdown: '/breakdown',
    associate: '/associate',
    settlements: '/settlements',
    reports: '/reports',
    invoicePreview: '/invoice-preview',
    trailer: '/trailer',
    reassigntrailer: '/reassigntrailer',
    deathLoss: '/deathLoss',
    driver: '/driver',
    trailerincome: '/trailerincome',
    download: '/download',
    qbuser: '/qbuser',
    qbusers: '/qbusers',
    activityLog: '/activitylog',
    duplicateLoads: '/duplicateLoads',
    declinedLoads: '/declinedLoads',
    driverDocumentStatus: '/driverdocumentstatus',
    driverLoadEarning: '/driverLoadEarning',
    driverLoadIds: '/driverloadids',
    multipleShipmentsPreview: '/multipleShipmentsPreview',
    qbOnlineAuth: '/quickbooksonlineauth',
    byshipment: '/by-shipment',
    bycargoDetails: '/by-cargo-details',
    driverloads: '/driverloads',
    publishRequest: '/publishrequest',
    templates: '/templates',
    mcs: '/mcs',
    orders: '/orders',
    status: '/status',
    shipmentDrafts: '/shipment-drafts',
    locations: '/locations',
    configure: '/configure',
    buildShipment: '/build-shipment',
    permanent: '/permanent',
};
